import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Typography } from 'antd';
import { ImageTheme } from '../../../../../components/images';
import { color } from '../../../../../resources/color';
import { ButtonTheme } from '../../../../../components/buttons';
import { useModal } from '../../../../../components/modal/hooks/useModal';
import { ChageDateBooking } from './modals/ChageDateBooking';
import { ComfirmDateBooking } from './modals/ComfirmDateBooking';

const { Text } = Typography;
export const WaitConfirmContentCard = memo((props) => {
  const { item } = props;
  const { open: openChangeNewBookingDate, onToggle: onToggleChangeNewBookingDate } = useModal();
  const { open: openConfirmDate, onToggle: onToggleConfirmDate } = useModal();
  const productImageUrl = item && item.productImageUrl ? item.productImageUrl : '';
  const warrantyCode = item && item.warrantyCode ? item.warrantyCode : '-';
  const claimCode = item && item.claimCode ? item.claimCode : '-';
  const mobileModelName = item && item.mobileModelName ? item.mobileModelName : '-';
  const productName = item && item.productName ? item.productName : '-';
  const telephone = item && item.telephone ? item.telephone : '-';
  const expireDate = item && item.expireDate ? moment(item.expireDate).format('DD/MM/YYYY') : '-';
  const bookingDate =
    item && item.bookingDate ? moment(item.bookingDate).format('DD/MM/YYYY') : '-';
  const storeType = item.storeType;

  return (
    <div
      style={{
        borderRadius: '0px 25px 25px 0px',
        padding: '5px',
        boxSizing: 'border-box',
        lineHeight: '1.5714285714285714',
        backgroundColor: '#ffffff',
        border: '1px solid #f0f0f0',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        marginBottom: '10px',
      }}
    >
      <Row gutter={10} style={{ paddingLeft: '10px' }}>
        <Col className="gutter-row" span={8}>
          <Row>
            <ImageTheme
              src={productImageUrl}
              style={{ width: '100%', height: '100%', objectFit: 'cover', marginTop: '20px' }}
            />
          </Row>
        </Col>
        <Col className="gutter-row" span={16}>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รหัสรับประกัน:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.blueFocus, fontSize: 12 }}>
                {warrantyCode}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รหัสการเคลม:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.blueFocus, fontSize: 12 }}>
                {claimCode}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รุ่น:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {mobileModelName}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`ชื่อสินค้า:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {productName}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`สิ้นสุดรับประกัน:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {expireDate}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`เบอร์ลูกค้า:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.blueFocus, fontSize: 12 }}>
                {telephone}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        gutter={10}
        style={{
          marginTop: '30px',
          padding: '10px',
          backgroundColor: color.light_blue,
          borderRadius: '0 0 25px 0',
        }}
      >
        <Col span={24}>
          <Row>
            <Col span={8} style={{ textAlign: 'start' }}>
              <Text style={{ fontSize: 15 }}>{`สถานะการเคลม: `}</Text>
            </Col>
            <Col span={16}>
              <Text strong style={{ fontSize: 15, color: color.blueFocus }}>
                ลูกค้ารอรับบริการวันที่ {bookingDate}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={12} style={{ textAlign: 'center' }}>
              {storeType !== 'STORE' && (
                <>
                  <ButtonTheme useFor="BOOKING_NEW_DATE" onClick={onToggleChangeNewBookingDate} />
                  {openChangeNewBookingDate && (
                    <ChageDateBooking
                      open={openChangeNewBookingDate}
                      onToggle={onToggleChangeNewBookingDate}
                      item={item}
                    />
                  )}
                </>
              )}
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              <ButtonTheme useFor="CONFIRM_DATE" onClick={onToggleConfirmDate} />
              {openConfirmDate && (
                <ComfirmDateBooking
                  open={openConfirmDate}
                  onToggle={onToggleConfirmDate}
                  item={item}
                />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
});

WaitConfirmContentCard.propTypes = {
  item: PropTypes.shape({
    productImageUrl: PropTypes.string,
    warrantyId: PropTypes.number,
    warrantyCode: PropTypes.string,
    mobileModelName: PropTypes.string,
    productName: PropTypes.string,
    createDate: PropTypes.string,
    expireDate: PropTypes.string,
    channelBuyName: PropTypes.string,
    fullName: PropTypes.string,
    telephone: PropTypes.string,
    warrantyStatus: PropTypes.string,
  }),
};
WaitConfirmContentCard.defaultProps = {
  item: {
    productImageUrl: '',
    warrantyId: 0,
    warrantyCode: '-',
    mobileModelName: '-',
    productName: '-',
    channelBuyName: '-',
    fullName: '-',
    telephone: '-',
    createDate: '-',
    expireDate: '-',
    warrantyStatus: '',
  },
};
